import React from 'react';
import {Container, Row, Col, Card, CardBody, CardTitle} from 'reactstrap';
import './trainingPrograms.css';

const TrainingPrograms = () => {
    return(
        <div className='mb-5 pb-5'>
            <Container>
                <Row className='justify-content-center'>
                    <Col className='text-center'>
                        <div className='position-relative pb-3'>
                            <h1 className='fw-500 fc-line text-center'>Training Programs Offered</h1>
                        </div>
                        
                    </Col>
                </Row>
                <Row className='justify-content-center'>
                    <Col xs={{ size: 12 }} md={{ size: 5}} className='pt-5'>
                        <Card className='tp-card'>
                            <CardBody className='tp-card-body py-3 px-4'>
                                <div className='position-relative text-center pl-3 pr-3 pb-3 tp-underline'>
                                    <h3>Introduction to AWS</h3>
                                    <p>Learn foundational knowledge of Amazon Web Services and their cloud platform.</p>
                                </div>
                                <div className='py-5 px-1'>
                                    <h4 className='tp-title2'>Introduction Overview</h4>
                                    <div className='tp-list'>
                                        <ul className='mb-0'>
                                            <li>What is Cloud Computing?</li>
                                            <li>What are the advantages?</li>
                                            <li>AWS Infrastructure</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className='px-1'>
                                    <h4 className='tp-title2'>Course Overview</h4>
                                    <div className='tp-list'>
                                        <ul className='mb-0'>
                                            <li>Security in Cloud</li>
                                            <li>Virtual Private Cloud (VPC)</li>
                                            <li>CloudWatch Monitoring</li>
                                            <li>Types of scaling</li>
                                            <li>Types of databases</li>
                                            <li>and more...</li>
                                        </ul>
                                    </div>
                                </div>
                                
                            </CardBody>
                        </Card>
                    </Col>
                    <Col xs={{ size: 12 }} md={{ size: 5}} className='pt-5'>
                     <Card className='tp-card'>
                            <CardBody className='tp-card-body py-3 px-4'>
                                <div className='position-relative text-center pl-3 pr-3 pb-3 tp-underline'>
                                    <h3>AWS Certified Training</h3>
                                    <p>Become certified as Solution Architects at the associate level with this training.</p>
                                </div>
                                <div className='py-5 px-1'>
                                    <h4 className='tp-title2'>Introduction Overview</h4>
                                    <div className='tp-list'>
                                        <ul className='mb-0'>
                                            <li>What is Cloud Computing?</li>
                                            <li>What are the advantages?</li>
                                            <li>AWS Infrastructure</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className='px-1'>
                                    <h4 className='tp-title2'>Course Overview</h4>
                                    <div className='tp-list'>
                                        <ul className='mb-0'>
                                            <li>Security in Cloud</li>
                                            <li>Virtual Private Cloud (VPC)</li>
                                            <li>CloudWatch Monitoring</li>
                                            <li>Types of scaling</li>
                                            <li>Types of databases</li>
                                            <li>Elastic Compute Cloud (EC2) and Elastic Load Balancing (ELB)</li>
                                            <li>Identity and Access Management</li>
                                            <li>Simple Storage Service (S3)</li>
                                            <li>Glue/Athena</li>
                                            <li>Loosely Coupled Architecture and Event-Driven Processing</li>
                                            <li>and more...</li>
                                        </ul>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default TrainingPrograms;